import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../auth/services/auth.service';
import { API_BASE_URL } from '../services/api.config';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const apiBaseUrl = inject(API_BASE_URL);

  const isApiRequest = req.url.startsWith(apiBaseUrl);
  const isRefreshRequest = req.url.includes('/auth/refresh');
  const isLoginRequest = req.url.includes('/auth/login');
  const isPasswordRecoveryRequest =
    req.url.includes('/auth/forgot-password') ||
    req.url.includes('/auth/reset-password');

  let request = req;

  const token = authService.accessToken();

  if (isApiRequest && token && !isRefreshRequest) {
    request = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
  } else if (isApiRequest) {
    request = req.clone({
      withCredentials: true,
    });
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      const shouldTryRefresh =
        error.status === 401 &&
        isApiRequest &&
        !isRefreshRequest &&
        !isLoginRequest &&
        !isPasswordRecoveryRequest &&
        authService.hasSessionHint();

      if (!shouldTryRefresh) {
        return throwError(() => error);
      }

      return authService.refreshAccessToken().pipe(
        switchMap((newToken) => {
          const retryRequest = req.clone({
            setHeaders: {
              Authorization: `Bearer ${newToken}`,
            },
            withCredentials: true,
          });

          return next(retryRequest);
        }),
        catchError((refreshError) => {
          authService.clearAuthState();
          void router.navigate(['/login']);
          return throwError(() => refreshError);
        }),
      );
    }),
  );
};